export default function Philosophy() {
    return (
        <div className="container mx-auto my-16">
            <div className="md:space-y-0 md:space-x-4 flex items-center space-y-5 px-10 md:pt-[4rem] pt-[1rem] md:pb-20">
                <div className="md:w-5/12 md:text-left text-center">
                    <div className="md:w-2/4 md:hidden h-full">
                        <img
                            src="/assets/about-us/map-mobile.webp"
                            alt="about us"
                        />
                    </div>
                    <p className="md:text-[35px] md:leading-[2.5rem] text-3xl font-bold text-start md:pt-0 pt-10">
                        <span>Our Philosophy</span>
                    </p>
                    <br />
                    <p className="md:text-[20px] text-[18px] text-[#000000] md:mr-[2.75rem] text-start font-medium">
                        At Open Letter Marketing, we&apos;re not just about
                        offering products. We&apos;re about imparting a deep
                        understanding of the nuances of direct mail marketing.
                        Our approach is rooted in strategy, innovation, and
                        continuous improvement. We&apos;re committed to helping
                        our clients stay ahead of the curve, offering them tools
                        and insights that are simply unmatched.
                    </p>
                </div>
                <div className="md:w-7/12 md:block h-full hidden">
                    <img
                        src="/assets/about-us/map.webp"
                        alt="An orange, striped outline of a world map on a gray background. An orange location pin in the North American region contains a small icon of four stacked envelopes or houses."
                        title="Direct mail world map location graphic."
                    />
                </div>
            </div>
        </div>
    )
}
